











































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
@Component({
  components: {},
})
export default class TongueTextList extends Vue {
  @Prop()
  private tongues;
  @Prop()
  private pageCount;
  @Prop()
  private currentPage;
  private ifShowPatientDetail: boolean = false;
  private temp: any = {};
  /**
   * @description 需要刷新
   */
  private refresh() {
    this.$emit("refresh");
  }
  /**
   * @description 切换选中的舌图
   */
  private handleCheckedMessageChange(event, message) {
    console.log(message.selected);
    message.selected = !message.selected;
    this.$emit("trigger", message);
  }
}
